import { Controller } from "@hotwired/stimulus"

// Uploads an image to Panel::ImagesController (which returns { url: "..." })
// and inserts a markdown image link at the cursor position of a target textarea.
export default class extends Controller {
  static targets = ["input", "textarea", "trigger"]
  static values = { url: String }

  open() {
    this.inputTarget.click()
  }

  async submit() {
    const file = this.inputTarget.files[0]
    if (!file) return
    const original = this.triggerTarget.textContent
    this.triggerTarget.textContent = "enviando..."

    try {
      const fd = new FormData()
      fd.append("file", file)

      const res = await fetch(this.urlValue, {
        method: "POST",
        body: fd,
        headers: this.csrfHeaders()
      })
      const data = await res.json()
      if (!data.url) throw new Error(data.error || "upload falhou")

      this.insertSnippet(`![${file.name}](${data.url})`)
    } catch (err) {
      console.error(err)
      alert(`Erro no upload: ${err.message}`)
    } finally {
      this.triggerTarget.textContent = original
      this.inputTarget.value = ""
    }
  }

  insertSnippet(text) {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const end = ta.selectionEnd
    const before = ta.value.slice(0, start)
    const after = ta.value.slice(end)
    ta.value = `${before}${text}${after}`
    ta.selectionStart = ta.selectionEnd = start + text.length
    ta.focus()
    ta.dispatchEvent(new Event("input", { bubbles: true }))
  }

  csrfHeaders() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? { "X-CSRF-Token": meta.content } : {}
  }
}
